export default [
    {
      name: "cardReader",
      path: "/card-reader",
      component: () => import("../components/cardreader/index.vue"),
      meta: {
        requiresAuth: true,
        hasAccess: ["admin"],
        layout: "master",
        re_fetch: true,
      },
    }
  ];
  
  